import {useContext} from 'react';
import {ProfileContext} from 'stores/contexts/Profile';

export const useProfileStore = () => useContext(ProfileContext);
